import _createForOfIteratorHelper from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";

/*
 * Auto focus on mount original code: https://github.com/radix-ui/primitives/blob/8175208cdbb8577e53f1165678ee0ce28a801837/packages/react/focus-scope/src/FocusScope.tsx#L143
 * `getTabbableCandidates` original source: https://github.com/radix-ui/primitives/blob/8175208cdbb8577e53f1165678ee0ce28a801837/packages/react/focus-scope/src/FocusScope.tsx#L246
 */
function getTabbableCandidates(container) {
  var nodes = [];
  var walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    acceptNode: function acceptNode(node) {
      var isHiddenInput = node.tagName === 'INPUT' && node.type === 'hidden';

      if (node.disabled || node.hidden || isHiddenInput) {
        return NodeFilter.FILTER_SKIP;
      } // Workaround: don't check tabIndex for radio groups, since that would return -1 when this function is called. Instead, always return as tabbable.


      if (node.role === 'radiogroup') {
        return NodeFilter.FILTER_ACCEPT;
      } // `.tabIndex` is not the same as the `tabindex` attribute. It works on the
      // runtime's understanding of tabbability, so this automatically accounts
      // for any kind of element that could be tabbed to.


      return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });

  while (walker.nextNode()) {
    nodes.push(walker.currentNode);
  } // we do not take into account the order of nodes with positive `tabIndex` as it
  // hinders accessibility to have tab order different from visual order.


  return nodes;
}

function focusFirst(candidates) {
  var preventScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;

  var _iterator = _createForOfIteratorHelper(candidates),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var candidate = _step.value;

      // if focus is already where we want to go, we don't want to keep going through the candidates
      if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) {
        return;
      }

      candidate.focus({
        preventScroll: preventScroll
      });

      if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) {
        return;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}

function focusRadioGroupFirstIfExists(e) {
  var candidates = getTabbableCandidates(e.target); // Run the custom logic only if we found radiogroup in the tabbable candidates. Otherwise, yield to Radix's default behavior.

  if (candidates.some(function (candidate) {
    return candidate.getAttribute('role') === 'radiogroup';
  })) {
    e.preventDefault();
    focusFirst(candidates, true);
  }
}

export { focusRadioGroupFirstIfExists };